import { createPostPageApi } from '../../post-page/controller/create-post-page-api';

export const createOldPostPageController = ({ appParams, wixCodeApi }) => {
  return Promise.resolve({
    pageReady: () => {},
    exports: () => createPostPageApi(appParams.instance, wixCodeApi),
  }).catch(console.error);
};
